import type { DeepPartial } from '@luna/utils-ts';

import type { Trading } from '../../types';

export const tradingConfigHR: DeepPartial<Trading> = {
    alwaysRenderVolumeTypes: true,
    applyIdAsQueryParam: true,
    applySimpleSellForMarket: true,
    applySimpleSwitchForMarket: true,
    includeIsinInQuestionnaireUrl: true,
    noTimeDateFormat: true,
    orderTypesWithStaticWarning: ['FUND'],
    settlementAccountCountryId: true,
    shouldLoadTradingDocuments: true,
    showAllMarketPlaces: true,
    showLastPriceForSwitch: true,
    showMinimumVolumePriceForSwitch: true,
    showSettingsLinksInFees: true,
    showTargetPortfolio: false,
    showVenueForSwitch: true,
    tradingValidationStrategies: {
        accountNotAllowedToTradeFlag: true,
    },
};
